module.exports = __webpack_public_path__ + "2928664fe1fc6aca88583a6f606d60ba.svg";


//////////////////
// WEBPACK FOOTER
// ./static/images/appstore-badge.svg
// module id = 2091
// module chunks = 1